import React from "react";
import { hydrate } from "react-dom";
import { Provider } from "react-redux";
import { withSSR } from "react-i18next";
import configStore from "./Redux/store/configStore";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
// Import slick-carousel styles only in client side
import "slick-carousel/slick/slick.css";

const { store, persistor } = configStore({});
const ExtendedApp = withSSR()(App);

hydrate(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ExtendedApp initialLanguage={""} initialI18nStore={""} />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
